import script from "./motion-info-button.vue?vue&type=script&lang=js"
export * from "./motion-info-button.vue?vue&type=script&lang=js"

import "./motion-info-button.vue?vue&type=style&index=0&id=7ae0d1c0&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae0d1c0"]])

export default __exports__